export default __webpack_public_path__ + "static/media/follow-up-icon.57e899e7.svg";